import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getHotjarSettingsValues = (): Record<string, string> => {
  // The hotjarSettingsValues global is a stringified JSON object.
  return JSON.parse(getGlobalProperty<string>("hotjarSettingsValues") ?? "{}");
};
